export const languages = {
  en: {
    code: "en",
    name: "English",
    tmdbCode: "en-US",
    flag: "🇺🇸",
  },
  ko: {
    code: "ko",
    name: "한국어",
    tmdbCode: "ko-KR",
    flag: "🇰🇷",
  },
  ja: {
    code: "ja",
    name: "日本語",
    tmdbCode: "ja-JP",
    flag: "🇯🇵",
  },
} as const;

export type LanguageCode = keyof typeof languages;

export const defaultLanguage: LanguageCode = "en";

export const languageCodes = Object.keys(languages) as LanguageCode[];

/**
 * Get TMDB API language code from our language code
 */
export function getTMDBLanguageCode(lang: LanguageCode): string {
  return languages[lang].tmdbCode;
}

/**
 * Validate if a language code is supported
 */
export function isValidLanguage(lang: string): lang is LanguageCode {
  // Own keys only: `in` would also accept "constructor", "__proto__", ...
  return Object.hasOwn(languages, lang);
}

/**
 * Get language code with fallback to default
 */
export function getValidLanguage(lang: string | undefined): LanguageCode {
  if (!lang || !isValidLanguage(lang)) {
    return defaultLanguage;
  }

  return lang;
}
